const parallaxImages = document.querySelectorAll('.image-cover.is--poster img, .parallax');
document.addEventListener("DOMContentLoaded", () => {

const onScroll = () => {
    parallaxImages.forEach(img => {
    const wrapper = img.parentElement;
    const rect = wrapper.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Check if the image is visible on the screen
    if (rect.top <= windowHeight && rect.bottom >= 0) {
        // Calculate the scroll percentage (0 at bottom of screen, 1 at top)
        const scrollPercent = (windowHeight - rect.top) / (windowHeight + rect.height);
        
        // Map the percentage to a +10% to -10% range
        const yMove = 10 - (scrollPercent * 20); 
        
        // Apply the movement on top of our 1.25 scale
        img.style.transform = `scale(1.25) translateY(${yMove}%)`;
    }
    });
};

// Run on scroll and once on load
window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
});